<template>
  <div id="aside-layout-structure-page" class="page white" ref="asideLayoutStructure">
    <el-container class="content-aside">
      <!-- Left Side -->
      <el-main class="cpl-main">
        <!-- Top Actions -->
        <el-row :gutter="20" class="options">
          <!-- Dropdown Type Filter -->
          <el-col :span="5" class="filter-col">
            <el-button class="cstm-btn-grey">{{ $t('label.all') }}</el-button>
          </el-col>

          <!-- Tag Filter -->
          <el-col :span="19" class="tags-col">
            <el-tag class="cstm-tag-grey" closable>
              <!-- Sample Text Here -->
            </el-tag>
          </el-col>
        </el-row>

        <!-- Content -->
        <el-row :gutter="0" class="main-content-row">
          Main Content
        </el-row>
      </el-main>

      <!-- Right Side -->
      <el-aside class="cpl-aside">
        Right Content
      </el-aside>
    </el-container>
  </div>
</template>

<script src="./aside-layout-structure.js"></script>
<style lang="scss" src="./aside-layout-structure.scss"></style>
